import type { FC } from "react";
import type { RouteObject } from "react-router";
import { lazy } from "react";
import { useRoutes } from "react-router-dom";

import LayoutPage from "../pages/layout";
import LoginPage from "../pages/login";

const RouterDashboard = lazy(
  () => import(/* webpackChunkName: "route-permission"*/ "../pages/dashboard")
);

const RouterProject = lazy(
  () => import(/* webpackChunkName: "route-permission"*/ "../pages/project")
);

const RouterProjectAdd = lazy(
  () =>
    import(
      /* webpackChunkName: "route-permission"*/ "../pages/project/add.project"
    )
);

const RouterProjectEdit = lazy(
  () =>
    import(
      /* webpackChunkName: "route-permission"*/ "../pages/project/edit.project"
    )
);

const RouterUserType = lazy(
  () => import(/* webpackChunkName: "route-permission"*/ "../pages/userType")
);

const RouterUserTypeAdd = lazy(
  () =>
    import(
      /* webpackChunkName: "route-permission"*/ "../pages/userType/add.userType"
    )
);

const RouterUserTypeEdit = lazy(
  () =>
    import(
      /* webpackChunkName: "route-permission"*/ "../pages/userType/edit.userType"
    )
);

const RouterRagFile = lazy(
  () => import(/* webpackChunkName: "route-permission"*/ "../pages/ragFile")
);

const RouterRagFileAdd = lazy(
  () =>
    import(
      /* webpackChunkName: "route-permission"*/ "../pages/ragFile/add.ragFile"
    )
);

const RouterRagFileEdit = lazy(
  () =>
    import(
      /* webpackChunkName: "route-permission"*/ "../pages/ragFile/edit.ragFile"
    )
);

const RouterQuestion = lazy(
  () => import(/* webpackChunkName: "route-permission"*/ "../pages/question")
);

const RouterQuestionAdd = lazy(
  () =>
    import(
      /* webpackChunkName: "route-permission"*/ "../pages/question/add.question"
    )
);

const RouterQuestionEdit = lazy(
  () =>
    import(
      /* webpackChunkName: "route-permission"*/ "../pages/question/edit.question"
    )
);

const RouterLog = lazy(
  () => import(/* webpackChunkName: "route-permission"*/ "../pages/log")
);

const RouterUser = lazy(
  () => import(/* webpackChunkName: "route-permission"*/ "../pages/user")
);

const RouterUserAdd = lazy(
  () =>
    import(/* webpackChunkName: "route-permission"*/ "../pages/user/add.user")
);

const RouterUserEdit = lazy(
  () =>
    import(/* webpackChunkName: "route-permission"*/ "../pages/user/edit.user")
);

const routeList: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: <LayoutPage />,
    children: [
      {
        path: "/",
        element: <RouterDashboard />,
      },
      {
        path: "project",
        element: <RouterProject />,
      },
      {
        path: "project/add",
        element: <RouterProjectAdd />,
      },
      {
        path: "project/edit",
        element: <RouterProjectEdit />,
      },
      {
        path: "userType",
        element: <RouterUserType />,
      },
      {
        path: "userType/add",
        element: <RouterUserTypeAdd />,
      },
      {
        path: "userType/edit",
        element: <RouterUserTypeEdit />,
      },
      {
        path: "ragFile",
        element: <RouterRagFile />,
      },
      {
        path: "ragFile/add",
        element: <RouterRagFileAdd />,
      },
      {
        path: "ragFile/edit",
        element: <RouterRagFileEdit />,
      },
      {
        path: "question",
        element: <RouterQuestion />,
      },
      {
        path: "question/add",
        element: <RouterQuestionAdd />,
      },
      {
        path: "question/edit",
        element: <RouterQuestionEdit />,
      },
      {
        path: "log",
        element: <RouterLog />,
      },
      {
        path: "user",
        element: <RouterUser />,
      },
      {
        path: "user/add",
        element: <RouterUserAdd />,
      },
      {
        path: "user/edit",
        element: <RouterUserEdit />,
      },
    ],
  },
];

const RenderRouter: FC = () => {
  const element = useRoutes(routeList);

  return element;
};

export default RenderRouter;
